/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const CardUnlocked = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M18.5 10C19.8858 10 21.0076 11.0946 21.2155 12.5005L19.6844 12.5001C19.5147 11.911 19.0372 11.5 18.5 11.5C17.8283 11.5 17.25 12.1425 17.25 12.9722L17.249 14H23V21H14V14H15.749L15.75 12.9722C15.75 11.3473 16.9626 10 18.5 10ZM21.5 15.5H15.5V19.5H21.5V15.5ZM19 3V8.5H2.5V15.5L12.499 15.5V17H1V3H19ZM10 12.5V14H4V12.5H10ZM17.5 4.5H2.5V6H17.5V4.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
